import './App.css';
import { Rutas } from './routing/rutas';

function App() {
  return (
    <div className='layout'>
        <Rutas />
    </div>
  );
}

export default App;
